import React from 'react';
import { FormControl, Grid, MenuItem, Select } from '@mui/material';
import SearchFilter from '../../../components/filters/SearchFilter';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

const CATEGORY_OPTION_LABELS = {
  E_INVOICE: { key: 'e_invoice', fallback: 'E-Invoice' },
  CUSTOMER: { key: 'customer', fallback: 'Customer' },
  SUPPLIER: { key: 'supplier', fallback: 'Supplier' },
  PRODUCT: { key: 'product', fallback: 'Product' },
};

const BulkUploadListFilters = ({
  filters,
  selectedFilter,
  selectedStatus,
  onFilterChange,
  searchTerm,
  onSearchChange,
  onSearchKeyPress,
  onDateRangeChange,
  onStatusChange,
  showCategoryFilter = false,
  selectedCategory = 'E_INVOICE',
  onCategoryChange,
  categoryFilterOptions = ['E_INVOICE', 'CUSTOMER'],
}) => {
  const { bulkUpload } = useTranslatedMessages();
  const statusOptions = bulkUpload?.filters?.status_options ?? {};
  const categoryOptions = bulkUpload?.filters?.category_options ?? {};

  const renderFilter = (filter) => {
    switch (filter.type) {
      case 'search':
        return (
          <SearchFilter
            key={filter.type}
            filter={filter}
            selectedFilter={selectedFilter}
            onFilterChange={onFilterChange}
            searchTerm={searchTerm}
            onSearchChange={onSearchChange}
            onSearchKeyPress={onSearchKeyPress}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Grid item xs={12} sx={{ padding: '2px' }} container justifyContent="space-between" alignItems="center" spacing={1}>
      <Grid item xs={12} sx={{ mb: 2 }} container spacing={1}>
        <Grid item>
          <FormControl sx={{ padding: '1px', minWidth: 120 }}>
            <Select
              value={selectedStatus}
              onChange={onStatusChange}
              displayEmpty
              size="small"
              sx={{ fontSize: '0.875rem', padding: '1px' }}
              variant="outlined"
            >
              <MenuItem key="default" value={''}>
                {statusOptions.all ?? 'All'}
              </MenuItem>
              <MenuItem key="uploaded" value={'UPLOADED'}>
                {statusOptions.uploaded ?? 'Uploaded'}
              </MenuItem>
              <MenuItem key="processing" value={'PROCESSING'}>
                {statusOptions.processing ?? 'Processing'}
              </MenuItem>
              <MenuItem key="completed" value={'COMPLETED'}>
                {statusOptions.completed ?? 'Completed'}
              </MenuItem>
              <MenuItem key="failed" value={'FAILED'}>
                {statusOptions.failed ?? 'Failed'}
              </MenuItem>
              <MenuItem key="upload_failed" value={'UPLOAD_FAILED'}>
                {statusOptions.upload_failed ?? 'Upload Failed'}
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>
        {showCategoryFilter && (
          <Grid item>
            <FormControl sx={{ padding: '1px', minWidth: 160 }}>
              <Select
                value={selectedCategory}
                onChange={onCategoryChange}
                size="small"
                sx={{ fontSize: '0.875rem', padding: '1px' }}
                variant="outlined"
              >
                {categoryFilterOptions.map((option) => {
                  const labelConfig = CATEGORY_OPTION_LABELS[option] ?? {
                    key: option.toLowerCase(),
                    fallback: option,
                  };
                  return (
                    <MenuItem key={option} value={option}>
                      {categoryOptions[labelConfig.key] ?? labelConfig.fallback}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
        )}
      </Grid>
      <Grid item container spacing={1} justifyContent="flex-end">
        {filters.map((filter) => renderFilter(filter))}
      </Grid>
    </Grid>
  );
};

export default BulkUploadListFilters;
